import React from 'react';

export default function LeafBackground() {
  const leafUrl = "https://assets.auxodev.dk/assets/8eff581d-09aa-4f3c-b275-323f2d379ce9/79e7e851-d77e-41bd-848c-e5ba8f3c75ea.png";

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-10 select-none">
      {/* Inline styles to define smooth, natural floating and swaying animations */}
      <style>{`
        @keyframes leafFloatOne {
          0%, 100% {
            transform: translateY(0) rotate(0deg) scale(1);
          }
          50% {
            transform: translateY(-30px) rotate(12deg) scale(1.05);
          }
        }
        @keyframes leafFloatTwo {
          0%, 100% {
            transform: translateY(0) rotate(0deg) scale(1);
          }
          50% {
            transform: translateY(-20px) rotate(-18deg) scale(0.95);
          }
        }
        @keyframes leafFloatThree {
          0%, 100% {
            transform: translateY(0) rotate(0deg) scale(1);
          }
          50% {
            transform: translateY(-25px) rotate(8deg) scale(1.02);
          }
        }

        .animate-leaf-1 {
          animation: leafFloatOne 12s ease-in-out infinite;
        }
        .animate-leaf-2 {
          animation: leafFloatTwo 16s ease-in-out infinite;
        }
        .animate-leaf-3 {
          animation: leafFloatThree 14s ease-in-out infinite;
        }
        .animate-leaf-4 {
          animation: leafFloatOne 18s ease-in-out infinite;
          animation-delay: -3s;
        }
        .animate-leaf-5 {
          animation: leafFloatTwo 15s ease-in-out infinite;
          animation-delay: -5s;
        }
        .animate-leaf-6 {
          animation: leafFloatThree 20s ease-in-out infinite;
          animation-delay: -2s;
        }
      `}</style>

      {/* Top Left Leaf */}
      <img 
        src={leafUrl}
        alt=""
        className="absolute top-[12%] left-[-4%] md:left-[2%] w-32 md:w-44 opacity-[0.05] animate-leaf-1"
        style={{ transformOrigin: 'center' }}
      />

      {/* Top Right Leaf */}
      <img 
        src={leafUrl}
        alt=""
        className="absolute top-[25%] right-[-5%] md:right-[4%] w-24 md:w-36 opacity-[0.03] animate-leaf-2 rotate-45"
        style={{ transformOrigin: 'center' }}
      />

      {/* Mid Left Leaf */}
      <img 
        src={leafUrl}
        alt=""
        className="absolute top-[48%] left-[-3%] md:left-[5%] w-28 md:w-40 opacity-[0.05] animate-leaf-3 -rotate-12"
        style={{ transformOrigin: 'center' }}
      />

      {/* Mid Right Leaf */}
      <img 
        src={leafUrl}
        alt=""
        className="absolute top-[62%] right-[-3%] md:right-[2%] w-36 md:w-48 opacity-[0.03] animate-leaf-4 rotate-90"
        style={{ transformOrigin: 'center' }}
      />

      {/* Bottom Left Leaf */}
      <img 
        src={leafUrl}
        alt=""
        className="absolute bottom-[15%] left-[-5%] md:left-[3%] w-24 md:w-32 opacity-[0.03] animate-leaf-5 rotate-180"
        style={{ transformOrigin: 'center' }}
      />

      {/* Bottom Right Leaf */}
      <img 
        src={leafUrl}
        alt=""
        className="absolute bottom-[5%] right-[-4%] md:right-[6%] w-32 md:w-40 opacity-[0.05] animate-leaf-6 -rotate-45"
        style={{ transformOrigin: 'center' }}
      />
    </div>
  );
}
